import { Col, Form, Input, Row, Select, Spin } from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useContext, useState } from "react";
import { adminContext } from "../../Common/PageRoute";
import { useNavigate } from "react-router-dom";
import PracticesService from "../../Services/PracticesService";
import {
  LoadingOutlined,
} from "@ant-design/icons";
import { Utils } from "../../Utilities/Utils";
import { SAModal } from "../../Common/Custom Components/Ant design/SAModal";
import { usePractice } from "../../Context/PracticeContext";

const AddPractice = ({
  onDismiss,
}: {
  onDismiss: (data?: any) => void;
}) => {
  const [form] = useForm();
  const navigate = useNavigate();
  const { openNotification } = useContext(adminContext);
  const [isCloneSelected, setIsCloneSelected] = useState(false); // State to toggle confirmation message
  const [loading, setLoading] = React.useState(false);
  const { allPracticeIds, addPractice } = usePractice();

  const handleSave = async () => {
    try {
      setLoading(true);
      const value = await form.validateFields();
      const cloneId = value?.clonePractice;
      let res = await PracticesService.addPractices(value, cloneId);
      if (res.status) {
        addPractice({
          value: res?.result?.id,
          label: res?.result?.name,
        })
        navigate(`/practices/${res?.result?.id}`);
        openNotification("success", "Practice added successfully.");
        onDismiss(true);
      } else {
        openNotification("error", res.message);
      }
    } catch (error: any) {
      if (error?.errorFields) {
        // Validation error - AntD shows field errors
      } else {
        openNotification("error", "Failed to add practice");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <SAModal
      open={true}
      width={600}
      title="Add practice"
      okText="Save"
      cancelText="Cancel"
      isLoading={loading}
      onCancel={() => onDismiss(false)}
      onOk={handleSave}
    >
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Form form={form}>
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={12} lg={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Clone practice"
                name="clonePractice"
              >
                <Select
                  showSearch
                  className="select-height-28"
                  options={allPracticeIds}
                  onChange={(value) => setIsCloneSelected(!!value)} // Update state when an option is selected
                  placeholder="Select a practice to clone from"
                  title="Select a practice to clone from"
                  allowClear
                  filterOption={(input: any, option: any) => {
                    return option?.label
                      ?.toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} lg={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Practice name"
                name="name"
                rules={[
                  { required: true, message: "Name is required" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input className="line-height-28" placeholder="Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={12} lg={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Title"
                name={["userName", "title"]}
                // rules={[
                //   { required: true, message: "Title is required" },
                //   { validator: Utils.validateWhiteSpace },
                // ]}
              >
                <Select
                  disabled={false}
                  className="select-height-28"
                  placeholder="Title"
                  options={[
                    { value: "Mr", label: "Mr" },
                    { value: "Mrs", label: "Mrs" },
                    { value: "Miss", label: "Miss" },
                    { value: "Sir", label: "Sir" },
                    { value: "Ms", label: "Ms" },
                    { value: "Dr", label: "Dr" },
                    { value: "Prof", label: "Prof" },
                    { value: "Madam", label: "Madam" },
                    { value: "Ma'am", label: "Ma'am" },
                    { value: "Lord", label: "Lord" },
                    { value: "Lady", label: "Lady" },
                    { value: "Reverend", label: "Reverend" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="First name"
                name={["userName", "first"]}
                rules={[
                  { required: true, message: "First name is required" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="First name"
                  onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
                  onInput={(e: any) =>
                  (e.target.value =
                    e.target.value.length > 1
                      ? e.target.value
                      : e.target.value.toUpperCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Last name"
                name={["userName", "last"]}
                rules={[
                  { required: true, message: "Last name is required" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              // requiredMark={false}
              >
                <Input
                  disabled={false}
                  className="line-height-28"
                  placeholder="Last name"
                  onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
                  onInput={(e: any) =>
                  (e.target.value =
                    e.target.value.length > 1
                      ? e.target.value
                      : e.target.value.toUpperCase())
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[10, 10]}>
            <Col xs={24} sm={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Email is required" },
                  { validator: Utils.ValidateEmailFormat },
                ]}
              >
                <Input className="line-height-28" placeholder="Email" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Host"
                name="host"
                rules={[
                  { required: true, message: "Host is required" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input className="line-height-28" placeholder="Host" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Database name"
                name="database"
                rules={[
                  { required: true, message: "Database is requried" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input className="line-height-28" placeholder="Database name" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Identifier"
                name="identifier"
                rules={[
                  { required: true, message: "Identifier is required" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input className="line-height-28" placeholder="Identifier" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Connection string"
                name="connectionString"
                dependencies={["database"]}
                rules={[
                  { required: true, message: "Connection string is required" },
                  { validator: Utils.validateWhiteSpace },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const dbName = getFieldValue("database");

                      if (!value || !dbName) {
                        return Promise.resolve();
                      }

                      const match = value.match(/\.net\/([^?]+)/);

                      if (!match) {
                        return Promise.reject(
                          new Error("Invalid MongoDB connection string format"),
                        );
                      }

                      const dbFromConnection = match[1];

                      if (dbFromConnection === dbName) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        new Error(
                          `Database name mismatch. Expected "${dbName}" but found "${dbFromConnection}"`,
                        ),
                      );
                    },
                  }),
                ]}
              >
                <Input 
                  className="line-height-28"
                  placeholder="Connection string"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Company logo URL"
                name="logoUrl"
              >
                <Input
                  className="line-height-28"
                  placeholder="Company logo URL"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>

      {isCloneSelected && ( // Show the message if a practice is selected for cloning
        <Row className="px-3 py-1">
          <Col
            span={24}
            className="p-3"
            style={{ backgroundColor: "#eef2ff", borderRadius: 5 }}
          >
            <Row className="font-bold">Are you sure?</Row>
            <Row>You want to clone details from the selected practice.</Row>
          </Col>
        </Row>
      )}
    </SAModal>
  );
};

export default AddPractice;
